// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html

import firebase from "firebase/compat/app";

// Initialize Firebase
const config = {
  // apiKey: 'AIzaSyDFYIpJlgGZBHyjcaiIKgPAadzSofuYaCY',
  // authDomain: 'vuesax-admin.firebaseapp.com',
  // databaseURL: 'https://vuesax-admin.firebaseio.com',
  // projectId: 'vuesax-admin',
  // storageBucket: 'vuesax-admin.appspot.com',
  // messagingSenderId: '914001522995',

  apiKey: "AIzaSyBdTThHuDm5O2Nz_XbM_NlLc0PMlXJN7wM",
  authDomain: "englishtown-f8da9.firebaseapp.com",
  projectId: "englishtown-f8da9",
  storageBucket: "englishtown-f8da9.appspot.com",
  messagingSenderId: "1052324916479",
  appId: "1:1052324916479:web:23af340fc942ca281bb0ca",
  measurementId: "G-3BT95NQZSF",
};

firebase.initializeApp(config);
